// extracted by mini-css-extract-plugin
module.exports = {"paginationDiv":"Pagination_paginationDiv__3Zg0H","pageItem":"Pagination_pageItem__3_3-K"};